import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllDebt, getAllTransaksionet } from "../../store/slices/debtSlice";
import TableTransaksionet from "../../components/TableTransaksionet/TableTransaksionet";

const Transaksionet = () => {
  const dispatch = useDispatch();
  const payDebtStatus = useSelector((state) => state.debt.payDebtStatus);
  const loadingReset = useSelector((state) => state.debt.loadingResetPay);
  const [selectedStatus, setSelectedStatus] = useState("");
  const isSelected = (status) => selectedStatus === status;

  useEffect(() => {
    dispatch(getAllDebt());
  }, [payDebtStatus, loadingReset]);

  useEffect(() => {
    dispatch(
      getAllTransaksionet({ page: 1, limit: 8, status: selectedStatus })
    );
  }, [selectedStatus]);

  return (
    <div>
      <div className="pt-16 pb-5 px-8 sm:px-0 sm:p-2 flex flex-wrap justify-center gap-4">
        {[
          {
            key: "",
            label: "Të gjitha abonimet",
            bg: "bg-[#396AFF]",
            selectedBg: "bg-blue-700",
            border: "border-blue-800",
          },
          {
            key: "pending",
            label: "Abonimet në pritje",
            bg: "bg-[#FFBB38]",
            selectedBg: "bg-yellow-600",
            border: "border-yellow-700",
          },
          {
            key: "approved",
            label: "Abonimet e aktivizuara",
            bg: "bg-[#5EC269]",
            selectedBg: "bg-green-700",
            border: "border-green-800",
          },
          {
            key: "expired",
            label: "Abonimet e skaduara",
            bg: "bg-[#DD524C]",
            selectedBg: "bg-red-700",
            border: "border-red-800",
          },
        ].map(({ key, label, bg, selectedBg, border }) => (
          <div
            key={key}
            className={`block w-full md:w-60 p-3 text-sm border rounded-2xl text-center cursor-pointer transform transition-all duration-300 ease-in-out
        ${
          isSelected(key)
            ? `${selectedBg} text-white ${border} shadow-xl scale-105 -translate-y-1`
            : `${bg} text-white border-gray-300`
        }`}
            onClick={() => setSelectedStatus(key)}
          >
            <p className="font-semibold tracking-wide">{label}</p>
          </div>
        ))}
      </div>

      <div className="m-2 md:m-10 p-2 md:p-6 bg-white rounded-3xl">
        <p className="text-xl mb-4 text-left">Transaksionet</p>
        <TableTransaksionet status={selectedStatus} />
      </div>
    </div>
  );
};

export default Transaksionet;
